<template>
    <b-container v-if="result">
      <ValidationObserver ref="bookingForm" slim>
        <b-form name="BookingPaxFrm" novalidate>
          <b-row class="row-1">
            <b-col sm="12">
              <b-card class="chr-card-tour">
                <b-card-header class="px-2">
                  <ResultHeader :result="result" @info="onInfo([result])">
                    <span><translate>from</translate>: <span class="text-price font-weight-bold">{{ price }} {{ result.currency  }} </span> </span>
                  </ResultHeader>
                </b-card-header>
                <b-row>
                  <b-col sm="12">
                    <DACD :result="result" />
                  </b-col>
                </b-row>
                <!--/-->
                <b-row class="mb-3">
                  <b-col sm="3">
                    <Carousel :result="result" />
                  </b-col>
                  <b-col sm="9">
                    <b-row>
                      <b-col sm="12">
                        <p style="white-space: pre-line;">
                          {{ result.description }}
                        </p>
                      </b-col>
                    </b-row>
                  </b-col>
                </b-row>
                <b-row class="mb-2">
                  <b-col sm="1">
                    <h6 v-b-toggle="`included-${result.id} not-included-${result.id}`"><b-icon icon="caret-down-fill"/></h6>
                  </b-col>
                  <b-col sm="6">
                    <h6 class="d-flex justify-content-between align-items-center package-title" v-b-toggle="`included-${result.id}`">
                      <span v-translate>Included services</span>
                      <span><b-icon icon="caret-down-fill"/></span>
                    </h6>
                    <b-collapse :id="`included-${result.id}`">
                      <b-card >
                        <p style="white-space: pre-line;">
                          {{ result.included }}
                        </p>
                      </b-card>
                    </b-collapse>
                  </b-col>
                  <b-col sm="5">
                    <h6 class="d-flex justify-content-between align-items-center package-title" v-b-toggle="`not-included-${result.id}`">
                      <span v-translate>Not included services</span>
                      <span><b-icon icon="caret-down-fill"/></span>
                    </h6>
                    <b-collapse :id="`not-included-${result.id}`">
                      <b-card>
                        <p style="white-space: pre-line;">
                          {{ result.not_included }}
                        </p>
                      </b-card>
                    </b-collapse>
                  </b-col>
                </b-row>
                <!--4/-->
                <b-row>
                  <b-col sm="12" class="printArea">
                    <h6 class="package-title">Passenger and Room Details</h6>
                    <b-table-simple stacked="sm" striped caption-top  class="table table-sm text-center mb-0" v-for="(room,rIndex) in pax" :key="rIndex">
                      <b-thead class="t-head thead-light text-center">
                        <b-tr>
                          <b-td colspan="8">
                              <!-- <b-form-group :label="'Room' + (rIndex + 1)"> -->
                              <ValidationProvider
                                name="selectie camera"
                                :rules="{ required: true }"
                                v-slot="vContext"
                                >
                                <b-form-radio-group
                                  :id="'room' + rIndex + 'Selection'"
                                  v-model="roomSelection[rIndex]"
                                  >
                                  <b-form-radio
                                      v-for="(dateRoom, dateRoomIndex) in date.rooms[rIndex]"
                                      :value="dateRoomIndex"
                                      :key="'room' + rIndex + 'dateRoom' + dateRoomIndex"
                                      :disabled="dateRoom.availability === 'unavailable'"
                                      >
                                      <span style="font-size: larger;">{{ $gettext(dateRoom.name)  }}</span>&nbsp;
                                      <span class="font-weight-bold text-danger" style="cursor: pointer" :id="'popover-target-room-' + {rIndex} + '-' + dateRoomIndex">
                                        {{ ( dateRoom.price.gross + dateRoom.price.tax).toFixed(2) }} {{ result.currency }}
                                      </span>
                                      <b-popover :target="'popover-target-room-' + {rIndex} + '-' + dateRoomIndex" triggers="hover" placement="bottom">
                                        <template #title>{{ dateRoom.price_name }}</template>
                                        {{ dateRoom.price_description }}
                                      </b-popover>
                                  </b-form-radio>
                                </b-form-radio-group>
                                <b-form-invalid-feedback id="conditions-live-feedback" :state="getValidationState(vContext)" ><translate>please select a room type for room</translate> {{ rIndex + 1 }}</b-form-invalid-feedback>
                              </ValidationProvider>
                          </b-td>
                        </b-tr>
                        <b-tr>
                          <b-td v-translate>Room</b-td>
                          <b-td></b-td>
                          <b-td v-translate>First name*</b-td>
                          <b-td v-translate>Middle name</b-td>
                          <b-td v-translate>Last name*</b-td>
                          <b-td v-translate>Age</b-td>
                          <b-td v-translate>Date of birth*</b-td>
                          <b-td v-translate>National ID Number*</b-td>
                        </b-tr>
                      </b-thead>
                      <b-tbody>
                        <template v-for="(p, pIndex) in room">
                          <PaxForm
                            class="noPrint"
                            v-model="room[pIndex]"
                            :travelDate="travelDate"
                            :room="rIndex + 1"
                            :showRoomNo="false"
                            :id="'room' + rIndex + 'pax' + pIndex"
                            :key="'pax' + pIndex"
                          />
                          <div :key="pIndex" style="display: none">
                            <tr>
                              <td>{{ rIndex + 1 }}</td>
                              <td>{{ room[pIndex].title }}</td>
                              <td>{{ room[pIndex].lname }} {{ room[pIndex].local_lname }}</td>
                              <td>{{ room[pIndex].fname }} {{ room[pIndex].local_fname }}</td>
                              <td>{{ room[pIndex].age }}</td>
                              <td>{{ room[pIndex].bdate }}</td>
                              <td>{{ room[pIndex].cnp }}</td>
                            </tr>
                          </div>
                        </template>
                      </b-tbody>
                    </b-table-simple>
                  </b-col>
                  <b-col sm="6">
                    <p class="mb-1">
                        <small><em class="text-danger"><translate>Fields marked with asterisks are mandatory</translate></em></small><br/>
                        <small><em class="text-danger"><translate>Attention</translate>* <translate>Persons under 18 years old are considered children</translate>!</em></small>
                    </p>
                  </b-col>
                  <b-col sm="6">
                    <p class="mb-0"><b v-translate>Telephone</b>*</p>
                    <ValidationProvider
                      name="telephone"
                      :rules="{ required: true }"
                      v-slot="vContext"
                      >
                      <b-form-group class="mb-0">
                        <b-form-input
                          type="text"
                          :name="'telephone'"
                          :placeholder="$gettext('telephone')"
                          class="form-control form-control-sm mb-0"
                          v-model="telephone"
                          size="sm"
                          :state="getValidationState(vContext)"
                          aria-describedby="telefon"
                        ></b-form-input>
                        <b-form-invalid-feedback id="telefon">{{ vContext.errors[0] }}</b-form-invalid-feedback>
                      </b-form-group>
                    </ValidationProvider>
                  </b-col>
                </b-row>
                <!--5/-->
                <b-row class="mb-2">
                  <b-col sm="12">
                    <hr class="mt-4 mb-2"/>
                    <b-card v-for="(dd, ddIndex) in result.detailed_descriptions" :key="'desc' + ddIndex" class="border-0" no-body>
                    <h6 class="d-flex justify-content-between align-items-center package-title w-100" v-b-toggle="`desc-${ddIndex}`">
                      <span>{{ dd.label }}</span>
                      <span><b-icon icon="caret-down-fill"/></span>
                    </h6>
                    <hr class="mt-0 mb-2"/>
                    <b-collapse :id="`desc-${ddIndex}`">
                      <p class="small" v-html="dd.description"></p>
                    </b-collapse>
                  </b-card>
                  </b-col>
                </b-row>
                <!--//-->
                <b-row class="mb-2">
                  <b-col class="col-sm-8">
                    <ElementsList
                      :date="date"
                      :currency="result.currency"
                      :pax="pax"
                      :selection="elementsSelection"
                      @toggleSeatMap="toggleSeatMap"
                      @change="onElementsSelectionChange" />
                  </b-col>
                  <b-col class="col-sm-4">
                    <h6 class="package-title" v-translate>Departure from</h6>
                    <b-card no-body class="border-top-0 mb-2">
                      <b-table-simple class="table table-sm mb-0" stacked="sm" striped>
                        <thead>
                          <tr>
                            <td class="ml-2"><translate>City</translate> / <translate>Zone</translate></td>
                            <td v-translate>Price</td>
                          </tr>
                        </thead>
                        <tbody>
                          <tr
                            v-for="(dep, elIndex) in date.departure_points"
                            :key="'dep' + elIndex"
                            >
                            <td>
                              <b-form-radio
                                  v-model="selectedDeparturePoint"
                                  :id="'dep' + elIndex"
                                  :value="elIndex"
                              >
                                <small>{{ dep.name }}</small>
                              </b-form-radio>
                            </td>
                            <td class="text-danger" nowrap>
                              <small>{{ (dep.price.gross + dep.price.tax).toFixed(2) }} {{ result.currency }}</small>
                            </td>
                          </tr>
                        </tbody>
                      </b-table-simple>
                    </b-card>
                    <SupplementsList
                      :date="date"
                      :currency="result.currency"
                      :pax="pax"
                      :selection="supplementsSelection"
                      @change="onSupplementsSelectionChange"
                      v-if="date.supplements.length"
                      />
                  </b-col>
                </b-row>
                <!--///-->
                <!--6/-->
                <b-row class="mb-2">
                  <b-col>
                    <div class="printArea">
                      <h6><translate>Agent notes</translate>*</h6>
                      <textarea v-model="notes" class="form-control noPrint">...</textarea>
                      <div class="printArea d-none"><p>{{notes}}</p></div>
                    </div>
                  </b-col>
                  <b-col md="4" v-if="paymentSchedule">
                    <b-card class="bg-light" no-body >
                      <b-card-header class="d-flex justify-content-between">
                        <b v-translate>Schedule Payments</b> <b class="text-primary">{{ result.currency }}</b>
                      </b-card-header>
                      <b-list-group flush>
                        <b-list-group-item v-for="(dd, ddIndex) in paymentSchedule" :key="'dd' + ddIndex">
                          {{ formatDate(dd.date) }} - <b>{{ ceil(dd.amount) || $gettext('balance') }}</b>
                        </b-list-group-item>
                      </b-list-group>
                    </b-card>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="12" class="printArea">
                    <!--<b-card class="bg-light">
                       <h6 class="package-title font-weight-bold border-bottom pb-1 text-primary">Penalizari in caz de anulare a rezervarii:</h6>
                      <small>
                       <p>Anularea rezervarilor efectuate se va face conform termenelor de anulare mentionate in anexa contractului de comercializare a pachetelor de servicii turistice pe care il regasiti in B2B la documente utile.<br/>
                        Penalizarile se aplica conform termenelor scadente mentionate in rezervare.
                       </p>
                      </small>
                    </b-card> -->
                  </b-col>
                  <b-col sm="12" class="mt-2">
                    <small>
                      <ValidationProvider
                        name="terms"
                        rules="is:acceptat"
                        vid="terms"
                        v-slot="vContext"
                        slim
                      >
                        <b-form-group>
                          <b-form-checkbox
                            id="conditions"
                            name="conditions"
                            v-model="termsAccepted"
                            :state="getValidationState(vContext)"
                            aria-describedby="conditions-live-feedback"
                            value="acceptat"
                            unchecked-value="neacceptat"
                            >
                            <span style="line-height: 2;"><translate>I have read and agree to the</translate> <span class="text-info pointer" @click="openTermsAndConditions"><translate>Terms and Conditions</translate></span></span>
                            </b-form-checkbox>
                            <b-form-invalid-feedback id="conditions-live-feedback" :state="getValidationState(vContext)"><translate>you have not accepted the terms and conditions</translate></b-form-invalid-feedback>
                        </b-form-group>
                      </ValidationProvider>
                    </small>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col md="12" class="printArea">
                    <b-card
                      bg-variant="light"
                      style="font-size:16px;"
                      class="text-center"
                    >
                      <b-form-group>
                        <span><translate>Total price</translate>: <span class="text-price font-weight-bold">{{ price }} {{ result.currency  }} </span> <small>(<translate>taxes included</translate>)</small></span>
                      </b-form-group>
                    </b-card>
                  </b-col>
                </b-row>
                <!--buttons-->
                <b-row class="mt-4">
                  <b-col>
                    <b-card
                      bg-variant="light"
                      no-body
                    >
                      <b-card-body class="p-1 p-md-3">
                        <div class="d-md-flex justify-content-md-between">
                          <b-button variant="secondary" size="sm" @click="back" class="mb-2 mb-md-0"><b-icon icon="chevron-left" v-translate/>Back to results</b-button>
                          <b-button-group size="sm">
                            <b-button variant="outline-warning" v-if="allowOption" @click="book({ status: 'option' })" v-translate>Options</b-button>
                            <b-button variant="primary" @click="book()" v-translate>Book</b-button>
                          </b-button-group>
                        </div>
                      </b-card-body>
                    </b-card>
                  </b-col>
                </b-row>
                <!--xx-->
              </b-card>
            </b-col>
          </b-row>
        </b-form>
      </ValidationObserver>

    <!-- offer? do we need this? -->
    <b-modal v-model="modal" title="Info Modal" size="xl" hide-header hide-footer>
      <div id="printArea">
        <ModalHeader @print="onPrint()" @download="onDownload()" @closeModal="onModalClose" />
        <!-- <b-card class="bg-light" no-body>
          <SearchParamsSummary :params="model.params"/>
        </b-card> -->
        <b-row v-for="result in infoResults" :key="'detailedInfo' + result.id" class="p-4">
          <DetailedResult
            :result="result"
          ></DetailedResult>
        </b-row>
      </div>
      <ModalFooter @closeModal="onModalClose" />
    </b-modal>

    <b-modal v-model="seatMapModal" title="Alege loc" hide-header hide-footer>
      <div class="d-flex justify-content-end">
        <span @click="seatMapModal = false">
          <b-icon icon="x-square-fill" class="text-primary" style="cursor:pointer;"/>
        </span>
      </div>
      <SeatMap
        :data="seatMapInfo"
        :pax="this.pax"
        />
    </b-modal>

    <!--terms and conditions-->
    <b-modal v-model="termsAndConditions" title="Termeni si Conditii" size="xl" hide-header hide-footer no-close-on-esc no-close-on-backdrop>
      <b-card id="printArea">
        <ModalHeader @print="onPrint()" @download="onDownload()" @closeModal="closeTermsAndConditions " />
        <TermsAndConditions/>
        <hr>
        <b-button variant="warning" class="float-right"  @click="closeTermsAndConditions">Accepta</b-button>
      </b-card>
    </b-modal>
     <!-- modal romanian terms and condition
     <b-modal v-model="termsConditionsRomania" title="Termeni si Conditii Transferuri Romannia" size="xl" hide-header hide-footer no-close-on-esc no-close-on-backdrop>
      <b-card>
        <TermsRomania/>
        <hr>
        <b-button variant="warning" class="float-right"  @click="closeTermsConditionsRomania">Accepta</b-button>
      </b-card>
    </b-modal>-->

    <!-- loading overlay -->
    <b-modal v-model="showOverlay" title="Status" size="xl" hide-header hide-footer no-close-on-esc no-close-on-backdrop>
      <b-card>
        <b-aspect class="align-items-center text-center" aspect="3">
          <b-spinner label="Asteptati, se incarca..." variant="warning"></b-spinner>
          <b-card-text>{{ overlayMessage }}</b-card-text>
        </b-aspect>
      </b-card>
    </b-modal>

    <!-- error overlay -->
    <b-modal v-model="showErrorOverlay" title="Eroare" size="xl" hide-header hide-footer no-close-on-esc no-close-on-backdrop>
      <b-card class="justify-content-center">
        <b-aspect aspect="3" class="align-items-center">
          <b-card-title class="font-weight-bold text-center">
            <b-icon icon="exclamation-triangle" class="text-danger mr-3"/>
            Am intampinat o problema!
          </b-card-title>
          <hr>
          <b-card-text class="lead text-muted" > - Din pacate rezervarea nu a putut fi inregistrata deoarce a aparut o problema.</b-card-text>
          <b-card-text class="lead text-muted" > - In general, acest lucru se intampla atunci cand pretul sau disponibilitatea produsului s-a modificat da cand ati cautat</b-card-text>
          <b-card-text class="lead text-muted" > Mesajul de eroare este: <b class="text-info">{{ errorMessage }}</b></b-card-text>
        </b-aspect>
        <hr>
        <b-button variant="warning float-right" size="sm" @click="back">Inapoi la rezultate</b-button>
      </b-card>
    </b-modal>
  </b-container>
</template>

<script>
import moment from 'moment'

import { getSearchResults, getSearchParams, paymentSchedule, book } from 'b2b-common/services/api/tour'
import { getSeatMapInfo } from 'b2b-common/services/api/bus'

import viewMixin from '../shared/mixins/search_views'
import toast from 'b2b-common/mixins/toast'

import ModalHeader from '@/app/private/shared/components/modal_header'
import ModalFooter from '@/app/private/shared/components/modal_footer'
import ResultHeader from './components/result_header.vue'
import DACD from './components/dacd.vue'
import DetailedResult from './components/detailed_result.vue'
import PaxForm from '@/app/private/shared/components/pax_form'
import validation from 'b2b-common/mixins/validation'
import TermsAndConditions from '@/app/private/shared/components/terms_and_conditions'

import SupplementsList from './components/supplements.vue'
import ElementsList from './components/elements.vue'
import SeatMap from './components/seat_map'
import Carousel from './components/carousel_images.vue'

export default {
  data () {
    return {
      result: null,
      date: null,
      traveDate: null,
      search: null,
      pax: [],
      roomSelection: [],
      supplementsSelection: [],
      elementsSelection: [],
      selectedDeparturePoint: null,
      notes: '',
      termsAccepted: false,
      termsAndConditions: false,
      termsAcceptedRomania: 'unaccepted',
      termsConditionsRomania: false,
      telephone: '',
      email: '',
      paymentSchedule: null,
      showErrorOverlay: false,
      showOverlay: false,
      overlayMessage: '',
      errorMessage: 'Eroare necunoscuta',
      invalidFormMessage: 'Formular invalid',
      seatMapModal: false,
      seatMapInfo: null
    }
  },
  mixins: [viewMixin, validation, toast],
  components: {
    ResultHeader,
    DACD,
    DetailedResult,
    ModalHeader,
    ModalFooter,
    PaxForm,
    TermsAndConditions,
    SupplementsList,
    ElementsList,
    SeatMap,
    Carousel
  },
  computed: {
    price () {
      let price = this.date.price.gross + this.date.price.tax
      this.date.rooms.forEach((room, roomIndex) => {
        let selection = this.roomSelection[roomIndex]

        if (selection === undefined || selection === null) {
          selection = room.findIndex(r => r.included)
        }
        price += room[selection].priceDiff.gross + room[selection].priceDiff.tax
      })
      this.date.supplements.forEach((supp, suppIndex) => {
        if (this.supplementsSelection[suppIndex] && supp.is_optional) {
          if (supp.application_model === 'per pax') {
            this.pax.forEach((room, roomIndex) => {
              room.forEach((pax, paxIndex) => {
                if (supp.pax[roomIndex][paxIndex]) {
                  const paxPrice = supp.pax_prices.find(p => (p.room_index === roomIndex) && (p.pax_index === paxIndex)).gross
                  price += paxPrice
                }
              })
            })
          } else {
            price += supp.price.gross + supp.price.tax
          }
        }
      })
      this.date.elements.forEach((el, elIndex) => {
        if (this.elementsSelection[elIndex] && el.is_optional) {
          if (el.application_model === 'per pax') {
            this.pax.forEach((room, roomIndex) => {
              room.forEach((pax, paxIndex) => {
                if (el.pax[roomIndex][paxIndex]) {
                  const paxPrice = el.pax_prices.find(p => (p.room_index === roomIndex) && (p.pax_index === paxIndex)).gross
                  price += paxPrice
                }
              })
            })
          } else {
            price += el.price.gross + el.price.tax
          }
        }
      })
      const departure = this.date.departure_points[this.selectedDeparturePoint]
      price += departure.priceDiff.gross + departure.priceDiff.tax
      return price
    },
    allowOption () {
      // date has to be at least 30 days from now
      return this.travelDate?.diff(moment(), 'days') >= 30
    }
  },
  methods: {
    openTermsAndConditions () {
      this.termsAndConditions = true
    },
    closeTermsAndConditions () {
      this.termsAndConditions = false
    },
    openTermsConditionsRomania () {
      this.termsConditionsRomania = true
    },
    closeTermsConditionsRomania () {
      this.termsConditionsRomania = false
    },
    back () {
      this.$router.push({
        name: 'Private/Tour/Search'
      })
    },
    formatDate (d) {
      return moment(d, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },
    ceil (no) {
      return Math.ceil(no)
    },
    onElementsSelectionChange ({ value, index }) {
      const newSelection = [...this.elementsSelection]
      newSelection[index] = value
      this.elementsSelection = newSelection
    },
    onSupplementsSelectionChange ({ value, index }) {
      const newSelection = [...this.supplementsSelection]
      newSelection[index] = value
      this.supplementsSelection = newSelection
    },
    async toggleSeatMap (data) {
      this.showOverlay = true
      try {
        const element = this.date.elements[data.element]
        const departureGroup = (data.direction === 'out') ? element.bus_out_departure_group : element.bus_in_departure_group
        const time = (data.direction === 'out') ? element.bus_out_departure_time : element.bus_in_departure_time
        const sm = await getSeatMapInfo({
          date: this.date.date,
          departureGroup,
          time
        })
        this.seatMapInfo = {
          ...sm,
          ...data
        }
        this.seatMapModal = true
      } catch (err) {
      } finally { this.showOverlay = false }
    },
    async book ({ status = 'confirmed' } = {}) {
      const success = await this.$refs.bookingForm.validate()
      if (!success) {
        this.addToast({ title: this.invalidFormMessage, message: 'Va rugam sa completati toate campurile obligatorii', variant: 'danger' })
        return Promise.reject(new Error(this.invalidFormMessage))
      }
      this.showOverlay = true
      try {
        const pax = [...this.pax.map(room => room.map(p => ({
          title: p.title,
          fname: p.fname.toUpperCase(),
          mname: p.mname.toUpperCase(),
          lname: p.lname.toUpperCase(),
          local_fname: p.local_fname.toUpperCase(),
          local_mname: p.local_mname.toUpperCase(),
          local_lname: p.local_lname.toUpperCase(),
          age: p.age,
          bdate: p.bdate,
          tel: this.telephone ? this.telephone : '',
          email: this.email ? this.email : '',
          seatSelections: p.seatSelections
        })))]

        // send telephone and notes
        let note = this.notes ? this.notes : ''
        if (this.telephone) note += '\nTelefon: ' + this.telephone
        if (this.email) note += '\nEmail: ' + this.email

        // now ok to create booking
        const bookParams = {
          tour: this.result.id,
          date: this.date.date,
          notes: note,
          extras: this.selectedExtras,
          pax: pax,
          // rooms selection
          rooms: this.roomSelection,
          // elements selection
          elements: this.elementsSelection.reduce((acc, value, index) => {
            if (value) {
              acc.push(
                {
                  index,
                  pax: this.date.elements[index].pax
                }
              )
            }
            return acc
          }, []),
          // supplements selection
          supplements: this.supplementsSelection.reduce((acc, value, index) => {
            if (value) {
              acc.push(index)
            }
            return acc
          }, []),
          // departure point selection
          departure_point: this.selectedDeparturePoint
        }
        if (status === 'option') bookParams.status = 'option'

        const res = await book(bookParams)
        this.$router.push({ name: 'Private/Bookings/View', params: { Id: res[0] } })
      } catch (err) {
        if (err.message !== this.invalidFormMessage) {
          this.errorMessage = err.message
          this.showErrorOverlay = true
        }
      } finally { this.showOverlay = false }
    }
  },
  async mounted () {
    const promises = {
      results: getSearchResults(),
      params: getSearchParams(),
      paymentSchedule: paymentSchedule({ tour: this.$route.params.tour.toString(), date: this.$route.params.date })
    }
    const resPromises = await Promise.all(Object.values(promises))
    const results = resPromises[0]
    this.params = resPromises[1]
    this.paymentSchedule = resPromises[2]
    const res = results.find(el => el.id.toString() === this.$route.params.tour.toString())
    if (res) {
      const date = res.dates.find(el => el.date === this.$route.params.date)
      this.travelDate = moment(date.date)

      const rooms = []
      this.params.rooms.forEach(room => {
        const pax = []
        for (let i = 0; i < room.adults; i++) {
          pax.push({
            title: 'Mr',
            fname: '',
            mname: '',
            lname: '',
            local_lname: '',
            local_mname: '',
            local_fname: '',
            age: 'adult',
            bdate: null,
            cnp: null,
            seatSelections: []
          })
        }
        room.ages.forEach(age => {
          pax.push({
            title: (age < 2) ? 'INF' : 'CHD',
            fname: '',
            mname: '',
            lname: '',
            local_lname: '',
            local_mname: '',
            local_fname: '',
            age: age,
            bdate: null,
            seatSelections: []
          })
        })
        rooms.push(pax)
      })
      this.pax = rooms
      this.date = date

      for (let i = 0; i < this.date.rooms.length; i++) {
        let selection = null
        if (this.date.rooms[i].length === 1) {
          selection = 0
        }
        this.roomSelection.push(selection)
      }

      for (let i = 0; i < this.date.supplements.length; i++) {
        this.supplementsSelection.push(!this.date.supplements[i].is_optional)
        this.date.supplements[i].pax = []
        if (this.date.supplements[i].application_model === 'per pax') {
          this.pax.forEach((room, roomIndex) => {
            this.date.supplements[i].pax.push([])
            room.forEach(p => {
              this.date.supplements[i].pax[roomIndex].push(!this.date.supplements[i].is_optional)
            })
          })
        }
      }

      for (let i = 0; i < this.date.elements.length; i++) {
        this.date.elements[i].pax = []
        if (this.date.elements[i].application_model === 'per pax') {
          this.pax.forEach((room, roomIndex) => {
            this.date.elements[i].pax.push([])
            room.forEach(p => {
              this.date.elements[i].pax[roomIndex].push(!this.date.elements[i].is_optional)
            })
          })
        }
        this.elementsSelection.push(!this.date.elements[i].is_optional)
      }

      this.selectedDeparturePoint = this.date.departure_points.findIndex(el => el.included)

      this.result = res
    }
  }
}
</script>
